import React, { Component } from 'react'
import { Row, Col } from 'antd'
import { observer, inject } from 'mobx-react'
import styles from './FooterMobile.module.css'
import { isMobile } from '~/utils'

const LINK_BRAND = ['https://static.insta360.com/assets/operation/0184/0757be5f0f1ac8020d93885cefe12622/logo@2x.png', 'http://www.insta360.com/']
const LINK_SOCIAL = [
  ['https://static.insta360.com/assets/operation/0184/5bc9ee4be83d4d7bc40ae7be6b3b1057/facebook@2x.png', 'https://www.facebook.com/Insta360-832149753506055/'],
  ['https://static.insta360.com/assets/operation/0184/7346bbf08b8ba458e7ec23cd0a359d74/instagram@2x.png', 'https://www.instagram.com/insta360/'],
  ['https://static.insta360.com/assets/operation/0184/bbcf6f4e2e8df73c3702843cdf6987eb/weibo@2x.png', 'http://weibo.com/insta360']
]

@inject('app')
@observer
class FooterMobile extends Component {
  render() {
    const { app } = this.props
    const { langs, locale } = app
    const { footer } = langs
    const MAILS = footer.mails
    const COPYRIGHT = footer.copyright

      return (
        <Row className={ styles.footer}>
          <Col span={24}>
            <Row className={ styles.top }>
              <Col span={6} className={ styles.brand }>
                <a href={LINK_BRAND[1]} alt="" target="_blank">
                  <img src={LINK_BRAND[0]} alt="" />
                </a>
              </Col>
              <Col span={18} className={ styles.social }>
                {
                  LINK_SOCIAL.map((social, key) => {
                    return <a href={social[1]} key={key} target="_blank"><img src={social[0]} alt="" /></a>
                  })
                }
              </Col>
            </Row>
          </Col>  

          <Col className={styles.mails} span={24}>
            {
              MAILS.map((mail,index) => {
                return <div key={index}>
                  <p>{mail[0]}</p>
                  <a href={`mailto:{mail[1]}`}>
                    {mail[1]}
                  </a>
                </div>
              })
            }
          </Col>  

          <Col className={styles.bottom} span={24}>
            <p> { COPYRIGHT.right }</p>
            <p> { COPYRIGHT.icp } </p>
          </Col>  
        </Row>
      )
  }
}
export default FooterMobile


// WEBPACK FOOTER //
// ./src/layouts/footer/FooterMobile.js